import { WeekLayout } from '..';
import {
    calendarPrintSettingsLayoutStandard,
    calendarPrintSettingsLayoutHorizontalAgenda,
    calendarPrintSettingsLayoutVerticalAgenda,
} from './getWeekLayouts.locstring.json';
import loc from 'owa-localize';

/** Returns localized options for week layouts */
export function getWeekLayouts() {
    return [
        {
            key: WeekLayout.Standard,
            text: loc(calendarPrintSettingsLayoutStandard),
        },
        {
            key: WeekLayout.Horizontal,
            text: loc(calendarPrintSettingsLayoutHorizontalAgenda),
        },
        {
            key: WeekLayout.Vertical,
            text: loc(calendarPrintSettingsLayoutVerticalAgenda),
        },
    ];
}
